import React, { useState } from "react"
import Calendar from "react-calendar"
import dateFormat from "dateformat"
import PropTypes from "prop-types"
import Layout from "../../../components/layouts/layout"
import "react-calendar/dist/Calendar.css"
import dayjs from "dayjs"
import _ from "lodash"
import moment from "moment-timezone"
import ProgressBar from "utils/stepper"

const Selfschedulappointment = ({
  apiData,
  openSlotsResults,
  setAppointmentDetails,
  setFunction,
}) => {
  const lett = ["S", "M", "T", "W", "T", "F", "S"]
  function getLetter(data) {
    return lett[data]
  }
  var [start_time, setState] = useState("00:00")
  var [end_time, setStateend] = useState("00:00")

  const userClick = event => {
    setStateend((end_time = event.currentTarget.dataset.end))
    setState((start_time = event.currentTarget.dataset.start))
  }
  const toCalendarType = weekStartDay =>
    weekStartDay === 0 ? "US" : "ISO 8601"
  const [value, setDate] = useState(
    new Date(
      dateFormat(openSlotsResults[0].date.toString(), "yyyy"),
      dateFormat(openSlotsResults[0].date.toString(), "m") - 1,
      dateFormat(openSlotsResults[0].date.toString(), "d")
    )
  )
  const [currentd, setCurrentd] = useState(
    new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(value)
  )
  const onDateChange = newDate => {
    setDate(newDate)
    setCurrentd(
      new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(newDate)
    )
  }
  function userExists(username) {
    console.log(currentd, JSON.stringify(openSlotsResults[0]))
    return openSlotsResults.some(function (el) {
      return el.date === currentd
    })
  }
  function timeFormate(Ftime) {
    return new Date("1970-01-01T" + Ftime + "Z").toLocaleTimeString("en-US", {
      timeZone: "UTC",
      hour12: true,
      hour: "numeric",
      minute: "numeric",
    })
  }
  const storeAppointmentData = async () => {
    var axondataObject = {
      date: dateFormat(value.toString(), "dddd, mmmm dS, yyyy"),
      starttime: timeFormate(start_time),
      endtime: timeFormate(end_time),
    }
    setAppointmentDetails(axondataObject)

    var axondata = JSON.stringify(axondataObject)
    console.log("axon-data:", axondata)
    localStorage.setItem("axon_time", axondata)
    const salesresults = JSON.parse(localStorage.getItem("results"))
    const localDateTimeStr = currentd + " " + start_time
    const utcStartDate = moment(localDateTimeStr).utc().format("MM/DD/YYYY")
    const utcStartTime = moment(localDateTimeStr).utc().format("HH:mm")

    try {
      var bodyContent = JSON.stringify({
        date: utcStartDate,
        time: utcStartTime,
        departmentId: salesresults.dept_id,
        patientId: salesresults.athena_id,
        salesforceId: salesresults.patient_id,
      })
      console.log(bodyContent)
      localStorage.setItem("bodyContent", bodyContent)
    } catch (error) {
      console.log("token error is coming===============================:")
      console.log("token Error Details:", error)
    }
  }

  return (
    <>
      <div className="mainSection">
        <Layout>
          <section className="progress-bar-section">
            <div className="progress-bar-wrapper">
              <ProgressBar activeStep={3} />
            </div>
          </section>
          <section className="patient-information-section">
            <div className="container">
              <div className="patient-heading">
                <h4>
                  Please pick a date and time to schedule your Welcome Visit
                </h4>
              </div>
              <div className="row mt-5">
                <div className="col-lg-10 col-md-12 mx-auto">
                  <div className="row slct-date">
                    <div className="col-lg-4 col-md-6 col-12">
                      <div className="insurance-heading">
                        <h5>1. Select a Date</h5>
                      </div>
                      <div className="insurance-date">
                        <div className="img-wrapper ctm-calendar">
                          <Calendar
                            calendarType={toCalendarType(0)}
                            formatShortWeekday={(locale, date) =>
                              getLetter(dayjs(date).format("d"))
                            }
                            onChange={onDateChange}
                            tileClassName={({ date, view }) => {
                              if (
                                openSlotsResults.find(
                                  x =>
                                    x.date ===
                                    new Intl.DateTimeFormat("en-US", {
                                      year: "numeric",
                                      month: "2-digit",
                                      day: "2-digit",
                                    }).format(date)
                                )
                              ) {
                                return "highlight"
                              }
                            }}
                            value={value}
                          />
                          <p className="schedule-message">
                            Our Welcome Visits fill up quickly. We suggest
                            selecting the first available appointment that works
                            for you.
                            <br />
                            <br />
                            If you cannot find one that works, simply close this
                            window and we will call you to complete scheduling.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <div className="insurance-heading">
                        <h5>2. Select a Time</h5>
                      </div>
                      <div className="insurance-time">
                        {userExists(currentd) ? (
                          openSlotsResults.map(
                            openSlot =>
                              openSlot.date === currentd && (
                                <ul>
                                  {_.orderBy(
                                    openSlot["time"],
                                    ["startTime"],
                                    ["asc"]
                                  ).map((si, index) => (
                                    <li key={index}>
                                      <a
                                        className={
                                          start_time === si.startTime
                                            ? "active"
                                            : "unactive"
                                        }
                                        data-end={si.endTime}
                                        data-start={si.startTime}
                                        onClick={userClick}
                                      >
                                        {timeFormate(si.startTime)}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              )
                          )
                        ) : (
                          <p>
                            Currently No Slots available. Please select another
                            day.
                          </p>
                        )}
                      </div>
                      <div></div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 btn-wrapper mt-5">
                      {start_time !== "00:00" && (
                        <button
                          className="btn btn-yellow float-right"
                          onClick={() => {
                            storeAppointmentData()
                            setFunction("ConfirmAppointment")
                          }}
                          type="button"
                        >
                          Continue Booking
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Layout>
      </div>
    </>
  )
}
Selfschedulappointment.propTypes = {
  apiData: PropTypes.object.isRequired,
  openSlotsResults: PropTypes.func.isRequired,
  setAppointmentDetails: PropTypes.func.isRequired,
  setFunction: PropTypes.func.isRequired,
}
export default Selfschedulappointment
